module.exports = __webpack_public_path__ + "img/instructor_img10.81c0b36e.png";